import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Menu,
  SearchBar,
  SearchIcon,
  ShareIcon,
  CloseIcon
} from './MenuStyles';
import Transition from 'react-transition-group/Transition';
import { Icon } from 'antd';
import MenuOptions from './MenuOptions';
import MenuSearch from './MenuSearch';

class MenuComponent extends React.Component {
  state = {
    openSearch: false
  };

  handleClose = () => {
    const { onClose } = this.props;
    this.setState({ openSearch: false }, onClose);
  };

  render() {
    const { show, contact } = this.props;
    const { openSearch } = this.state;
    return (
      <Transition
        timeout={{ enter: 0, exit: 200 }}
        in={show}
        unmountOnExit
        mountOnEnter
      >
        {state => (
          <Menu state={state}>
            <SearchBar>
              <SearchIcon
                onClick={() => this.setState({ openSearch: !openSearch })}
              >
                <Icon
                  type={openSearch ? 'menu-unfold' : 'search'}
                  theme="outlined"
                />
              </SearchIcon>

              <CloseIcon onClick={this.handleClose}>
                <Icon type="close" theme="outlined" />
              </CloseIcon>

              <ShareIcon onClick={() => window.open(contact.twitter, '_blank')}>
                <Icon type="twitter" theme="outlined" />
              </ShareIcon>
              <ShareIcon
                bottom="70px"
                onClick={() => window.open(contact.facebook, '_blank')}
              >
                <Icon type="facebook" theme="filled" />
              </ShareIcon>
              <ShareIcon
                bottom="120px"
                onClick={() => window.open(contact.instagram, "_blank")}
              >
                <Icon type="instagram" theme="filled" />
              </ShareIcon>
            </SearchBar>

            <CloseIcon onClick={this.handleClose}>
              <Icon type="close" theme="outlined" />
            </CloseIcon>

            <MenuOptions show={!openSearch} onClose={this.handleClose} />
            <MenuSearch show={openSearch} />
          </Menu>
        )}
      </Transition>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  contact: state.info.contact
});

export default withRouter(connect(mapStateToProps)(MenuComponent));



// WEBPACK FOOTER //
// ./src/components/Menu/MenuComponent.js